module.exports = __webpack_public_path__ + "static/kartchen5-484d70f2faf2e1727cf400d6c5a69880.png";